import { useRouter } from 'next/router';

export const useQueryParams = () => {
  const router = useRouter();
  const {
    bookingId,
    modified,
    notAcceptingBooking = 'true',
    phone = '',
    should_request_confirm: shouldRequestConfirm,
    slug,
    waitlistId,
    withAccountDetails = 'false'
  } = router?.query || {};

  return {
    bookingId: parsePathParam(bookingId),
    modified: convertStringToBool(modified),
    notAcceptingBooking: convertStringToBool(notAcceptingBooking),
    phone: parsePathParam(phone),
    shouldRequestConfirm: convertStringToBool(shouldRequestConfirm),
    slug: parsePathParam(slug),
    waitlistId: parsePathParam(waitlistId),
    withAccountDetails: convertStringToBool(withAccountDetails)
  };
};

export const convertStringToBool = (s: string | string[] | undefined) =>
  s === 'true';

/**
 *
 * parsePathParam makes sure that we resolve the different types
 * that can possibly come back from the router.query object.
 * If we're certain about our dynamic paths, then these cases will
 * most likely never happen, but this is to just make sure we can
 * pass down a string
 */
export const parsePathParam = (
  pathParam: string | string[] | undefined
): string =>
  Array.isArray(pathParam) ? pathParam[0] : pathParam == null ? '' : pathParam;
